import React from 'react';

export default () => (
  <h2>Not Found</h2>
);



// WEBPACK FOOTER //
// ./containers/NotFoundPage.js